// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "[data-v-64355a90] .el-form-item {\n  margin-bottom: 0.026042rem;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 108>"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B","file":"customerFilter.vue","sourcesContent":["/deep/.el-form-item {\n  margin-bottom: 0.026042rem;\n}"]}]);
// Exports
module.exports = exports;
